import { render, staticRenderFns } from "./PluginAdminConfirmDialog.vue?vue&type=template&id=04a93642&scoped=true&"
import script from "./PluginAdminConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./PluginAdminConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./PluginAdminConfirmDialog.vue?vue&type=style&index=0&id=04a93642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a93642",
  null
  
)

export default component.exports